export const scoreStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    maxWidth: "800px",
    margin: "auto",
  },
  scoreBox: {
    borderRadius: 4,
    textAlign: "center",
    color: "primary.contrastText",
    overflow: "hidden",
    display: "grid",
    gridTemplateColumns: "1fr auto",
    backgroundColor: "extraBackgrounds.darker",
    alignItems: "center",
    minHeight: { xs: 60, md: 80 },
  },
  rank: {
    width: { xs: 40, md: 60 },
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "background.paper",
    fontWeight: "bold",
    fontSize: { xs: "1.1rem", md: "1.5rem" },
    color: "text.primary",
  },
  teamName: {
    py: { xs: 1, md: 2 },
    px: { xs: 2, md: 4 },
    fontWeight: 700,
    alignItems: "center",
    display: "flex",
    flex: 1,
    height: "100%",
  },
};
